module.exports = __webpack_public_path__ + "fonts/VetoSans-MediumItalic_1.317a8fa5.woff";